module.exports = __webpack_public_path__ + "img/metal.14ffb150.png";